import { render, staticRenderFns } from "./BackofficeRoles.vue?vue&type=template&id=ea4b706e&scoped=true"
import script from "./BackofficeRoles.vue?vue&type=script&lang=js"
export * from "./BackofficeRoles.vue?vue&type=script&lang=js"
import style0 from "./BackofficeRoles.vue?vue&type=style&index=0&id=ea4b706e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4b706e",
  null
  
)

export default component.exports